var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Home"},[_c('div',{staticClass:"Home_content"},[_c('Nav'),_c('keep-alive',{attrs:{"exclude":"developDoc"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }